// import axios from 'axios';
// import { AppConfig } from "@/constants";
// const API_URL = AppConfig.API_BASE_URL + '/bulkUsers';
import api from "./api";

export const uploadExcelFile = (formData) => {

 return api.post("/bulkUsers/upload_bulk_users", formData, {
      requiresAuth: true,
      isMultipart: true,
  });

};

export const uploadSingleUser = (userData) => {
  return api.post("/bulkUsers/upload_single_user", userData, {
      requiresAuth: true,
  });
};

export const setupPassword = (token, password, pkg_id) => {
  return api.post(`/bulkUsers/setup-password`, { token, password, pkg_id }, {
      requiresAuth: true,
      isMultipart: true,
  });
};


export const getBulkUserDetails = (email) => {
  
  return api.get(`/bulkUsers/get_bulk_user_details/${email}`, {
    requiresAuth: true
  });
  
};

export const userHasPackage = () => {
  
  return api.get(`/package/hasOrgManagerPackage`, {
    requiresAuth: true
  });
  
};

export const getIncorrectRules = (testResultId) => {
  
  return api.get(`/bulkUsers/get_incorrect_rules/${testResultId}`, {
    requiresAuth: true
  });
  
};